import { render, staticRenderFns } from "./InformacionGeneralForm.vue?vue&type=template&id=250c633b&scoped=true&"
import script from "./InformacionGeneralForm.vue?vue&type=script&lang=ts&"
export * from "./InformacionGeneralForm.vue?vue&type=script&lang=ts&"
import style0 from "./InformacionGeneralForm.vue?vue&type=style&index=0&id=250c633b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250c633b",
  null
  
)

export default component.exports